import { Grid } from '@mui/material';
import styled from 'styled-components';

import DashboardAttendanceMetric from './DashboardAttendanceMetric';
import DashboardStudentFeedbackMetrics from './DashboardStudentFeedbackMetrics';
import DashboardStudentTalkTimeMetric from './DashboardStudentTalkTimeMetric';

const SecondRowContainer = styled(Grid)`
    margin-top: 36px;
`;

const GridItem = styled(Grid)`
    @media (min-width: 900px) : {
        padding: 0px 30px;
    }
    @media (min-width: 780px) : {
        padding: 0px 0px;
    }
    @media (min-width: 600px) : {
        padding: 0px 0px;
    }
`;

const DashboardSessionsSecondRow: React.FC = () => (
    <SecondRowContainer container>
        <Grid item xs={12} sm={12} md={4}>
            <DashboardAttendanceMetric/>
        </Grid>
        <GridItem item xs={6} sm={6} md={4}>
            <DashboardStudentTalkTimeMetric/>
        </GridItem>
        <Grid item xs={6} sm={6} md={4}>
            <DashboardStudentFeedbackMetrics/>
        </Grid>
    </SecondRowContainer>
);

export default DashboardSessionsSecondRow;
